import axios from 'axios';
const CONTROLLER_PATH = 'ActionToken';
class SapdMetroService {
    requestNew(entityType, entityId, isNewEntity) {
        return axios.get(CONTROLLER_PATH + '/RequestNew/' + entityType + '/' + entityId, {params: { isNewEntity: isNewEntity}}).then((response) => response.data);
    }
}

export default new SapdMetroService();
